<template>
  <nav :class="['nav-menu-section', isMini ? 'mini' : 'full']">
    <header class="header">
      <AdaptiveNavLink
        :name="section.name"
        :link="section.link"
        :active="active.section"
        :is-mini="isMini"
        :has-links="hasLinks"
        :features="features"
        @toggle="toggleSection"
      />
    </header>

    <div v-if="hasLinks">
      <ExpandY :open="showLinks">
        <div class="links">
          <AdaptiveNavLink
            v-for="link in section.links"
            :key="link.name"
            :link="link"
            :active="active.link"
            :features="features"
            :is-mini="isMini"
          />
        </div>
      </ExpandY>
    </div>
  </nav>
</template>


<script>
import AdaptiveNavLink from './AdaptiveNavLink.vue';
import ExpandY from '../../../components/ExpandY.vue';

export default {
  name: 'ComponentName',
  components: { AdaptiveNavLink, ExpandY },
  props: ['section', 'features', 'active', 'expandedSection', 'isMini'],
  data() {
    return {
      showLinks: false,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    hasLinks() {
      return this.section.links?.length;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    expandedSection(newSection, oldSection) {
      // Only allows one section to be expanded at a time
      // if(newSection !== this.section.name) this.showLinks = false
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {
    // Opens the active section when nav is opened
    if (!this.isMini && this.active.section?.name === this.section.name) {
      this.showLinks = true;
    }

    // Added per team feedback; Open all sections by default
    this.showLinks = true;
  },
  updated() {},
  methods: {
    toggleSection() {
      if (!this.showLinks) this.$emit('expand');
      this.showLinks = !this.showLinks;
    },
  },
};
</script>


<style scoped>
  .nav-menu-section {
    position: relative;
    min-width: 15em;
  }

  .links {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: stretch;
    gap: 0.25em;

    min-width: 12em;
    padding: 0.5em 0 0.5em 0;
    background-color: inherit;
  }

  /* Indent links under section title */
  /*
  .full .links {
    padding-left: 1em;
  }
  */
</style>
